import * as React from 'react';

import ImagePreviewModal from 'af-components/ImagePreviewModal';

interface OwnProps {
	showModal: boolean;
	onCloseModal: () => void;
	attachmentSrc: Nullable<string>;
}

const ImageAttachmentPreviewModal: React.FC<OwnProps> = (props) => {

	const {
		attachmentSrc,
		onCloseModal,
		showModal,
	} = props;

	if (!attachmentSrc) {
		return null;
	}

	return (
		<ImagePreviewModal
			closeModal={onCloseModal}
			imageSrc={attachmentSrc}
			showModal={showModal}
		/>
	);
};

export default React.memo(ImageAttachmentPreviewModal);
